// extracted by mini-css-extract-plugin
export default {"wrapper":"SharedFiles_wrapper__ld6Ad","title":"SharedFiles_title__Js0l3"};